import React from 'react';

const Count = () => {
  return ( <>
 <section  className="counts">
      <div className="container">
        <div className="row counters">
          <div className="col-lg-3 col-6 text-center">
            <span >100</span>
            <p>Clients</p>
          </div>
          <div className="col-lg-3 col-6 text-center">
            <span >100</span>
            <p>Projects</p>
          </div>
          <div className="col-lg-3 col-6 text-center">
            <span >24</span>
            <p>Hours Of Support</p>
          </div>
          <div className="col-lg-3 col-6 text-center">
            <span >10</span>
            <p>Hard Workers</p>
          </div>
        </div>
      </div>
    </section>
    </>);
}

export default Count;
